import { customerWords } from './engine-words';

/** What the review screen says when Paige could not do something for a reason that is not the person's. */
export const notJustNow =
  'Paige could not do that just now. Nothing was lost; try again in a minute.';

/**
 * The sentence a person reads for a refused call: Paige's own when it refused with one written for them
 * (a problem's detail, in Cortexa's words: a 4xx, or a 503 the API words itself, "Cortexa is restarting."),
 * `fallback` otherwise. Never a status number, a status's phrase, a problem's title (a machine token such as
 * `EngineUnavailable`), an unhandled error's text (500) or a gateway's (502).
 */
export function problemWords(status: number, body: unknown, fallback: string = notJustNow): string {
  const detail = detailOf(body);
  if (!detail || status === 500 || status === 502) return fallback;
  return customerWords(detail);
}

/** {@link problemWords} for a response not read yet: its JSON body when it has one. */
export async function responseWords(
  response: Response,
  fallback: string = notJustNow,
): Promise<string> {
  let body: unknown = null;
  try {
    body = await response.json();
  } catch {
    // Not a problem document: nothing in it was written for a person.
  }
  return problemWords(response.status, body, fallback);
}

function detailOf(body: unknown): string | null {
  if (typeof body !== 'object' || body === null) return null;
  const detail = (body as { detail?: unknown }).detail;
  return typeof detail === 'string' && detail.trim() ? detail.trim() : null;
}
